import { z } from 'zod';
import { isoDateTimeSchema, objectIdSchema } from './common.js';
import { passwordSchema } from './users.js';
/**
 * Connexion, mot de passe oublié, réinitialisation — `02` §1.
 * Session de 12 h glissantes, cookie opaque haché en base (`04` §6).
 */
export const SESSION_DURATION_HOURS = 12;
/** En-tête personnalisé exigé sur les mutations (protection CSRF, `04` §6). */
export const CSRF_HEADER = 'x-flux-csrf';
export const loginBodySchema = z.object({
    email: z.email(),
    password: z.string().min(1),
});
export const forgotPasswordBodySchema = z.object({
    email: z.email(),
});
export const resetPasswordBodySchema = z.object({
    token: z.string().min(1),
    password: passwordSchema,
});
export const sessionUserSchema = z.object({
    id: objectIdSchema,
    email: z.email(),
    name: z.string(),
    lastLoginAt: isoDateTimeSchema.nullable(),
});
export const sessionResponseSchema = z.object({
    user: sessionUserSchema,
    expiresAt: isoDateTimeSchema,
    csrfToken: z.string(),
});
/**
 * Réponse de `GET /auth/me` : l'utilisateur courant **et** le jeton CSRF dérivé
 * de sa session, pour qu'un onglet rouvert (cookie de session valide mais jeton
 * CSRF perdu de la mémoire) puisse de nouveau émettre des mutations sans
 * repasser par la connexion.
 */
export const meResponseSchema = sessionUserSchema.extend({
    csrfToken: z.string(),
});
//# sourceMappingURL=auth.js.map